export const breakpoints = {
  xs: '375px',
  sm: '480px',
  md: '640px',
  lg: '1024px',
  xl: '1200px',
  xxl: '1440px',
  xxxl: '1920px',
};
